import { useEffect, useRef } from "react";

export const DAY_PLACED = "placed";
export const DAY_COMPLETED = "completed";

export const DAY_BASIS_OPTIONS = [
  { label: "Day placed", value: DAY_PLACED },
  { label: "Day completed", value: DAY_COMPLETED },
];

export const basisParam = (basis) =>
  basis === DAY_PLACED || basis === DAY_COMPLETED ? `&date_basis=${basis}` : "";

export const useRefetchOnBasis = (basis, refetch) => {
  const mounted = useRef(false);
  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
      return;
    }
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- refetch is the closure of the render that changed the basis
  }, [basis]);
};
